import { render } from "./HeaderPart.vue?vue&type=template&id=070322d5"
const script = {}

import "./HeaderPart.vue?vue&type=style&index=0&id=070322d5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__